import {combineReducers} from 'redux';

import ekyc from './ekyc';

export default combineReducers({
  ekyc,
});
